// Concierge Enter tracking

import { trackButtonClick } from '@snowplow/browser-plugin-button-click-tracking';

export function enableEnterTracking() {
  document.addEventListener(
    'keydown',
    (e) => {
      if (e.key !== 'Enter' || e.shiftKey || e.isComposing || e.repeat) return;

      const textarea = e.target.closest('#main-container form textarea');
      if (!textarea || !textarea.value.trim()) return;

      const form = textarea.closest('form');
      const button = form?.querySelector("button[type='submit']");

      trackButtonClick({
        label:
          button?.dataset?.spButtonLabel ||
          button?.innerText ||
          button?.value ||
          '(empty)',
        id: button?.id || undefined,
        name: button?.name || undefined,
        classes: button?.classList?.length
          ? Array.from(button.classList)
          : undefined,
      });

      e.preventDefault();
      form?.requestSubmit();
    },
    true
  );
}
